import { Cog } from "lucide-react";

const Marquee = ({ items }) => (
  <div className="relative overflow-hidden border-y border-[#FF5500]/30 bg-[#0A0C0F] py-4" data-testid="models-marquee">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center" aria-hidden={half === 1}>
          {items.map((item, i) => (
            <span
              key={`${half}-${i}`}
              className="mx-7 flex items-center gap-7 whitespace-nowrap font-display text-sm uppercase tracking-[0.25em] text-neutral-400"
            >
              <Cog className="h-4 w-4 text-[#FF5500]" />
              {item}
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
